import { render, staticRenderFns } from "./DialogInfo.vue?vue&type=template&id=1c5b4e81&scoped=true&"
import script from "./DialogInfo.vue?vue&type=script&lang=js&"
export * from "./DialogInfo.vue?vue&type=script&lang=js&"
import style0 from "./DialogInfo.vue?vue&type=style&index=0&id=1c5b4e81&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5b4e81",
  null
  
)

export default component.exports